export default {
  heading: "var(--montserrat-font), var(--inter-font), system-ui, sans-serif",
  body: "var(--inter-font), system-ui, sans-serif",
  numerical: "var(--montserrat-font), var(--inter-font), system-ui",
};

/**
 * deprecated:
 * export default {
  heading:
    "MontserratVariable, InterVariable, -apple-system, system-ui, sans-serif",
  body: "InterVariable, -apple-system, system-ui, sans-serif",
  numerical:
    "MontserratVariable, InterVariable, -apple-system, system-ui, sans-serif",
};

 */
